import { render } from "./AddNewDishOptionModal.vue?vue&type=template&id=c206d378&lang=pug"
import script from "./AddNewDishOptionModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AddNewDishOptionModal.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__